let UTILS = require("../libs/utils.js");
var v7739;
var v7740;
module.exports = {
  id: "def",
  name: "Defuse",
  alias: "def",
  site: true,
  endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
  lives: 1,
  noRegen: true,
  teams: true,
  hitBoxPad: 0.5,
  gameStart: function (p9198) {
    p9198.warmupReset();
    p9198.lockMove();
  },
  realMov: true,
  winCondition: function (game) {
    var v7741;
    var vLN01227 = 0;
    var vLN01228 = 0;
    for (var vLN01229 = 0; vLN01229 < game.players.list.length; ++vLN01229) {
      v7741 = game.players.list[vLN01229].team;
      if (game.players.list[vLN01229].diffuses) {
        return v7741;
      }
      if (game.players.list[vLN01229].active) {
        if (v7741 == 1) {
          vLN01227++;
        } else if (v7741 == 2) {
          vLN01228++;
        }
      }
    }
    if (vLN01227 > 0) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (game) {
    var vLN01230 = 0;
    var v7742 = game.activeBomb ? 1 : 0;
    for (var vLN01231 = 0; vLN01231 < game.players.list.length; ++vLN01231) {
      if (game.players.list[vLN01231].diffuses) {
        return false;
      }
      if (game.players.list[vLN01231].lives > 0) {
        if (game.players.list[vLN01231].team == 1) {
          vLN01230++;
        } else {
          v7742++;
        }
      }
    }
    return vLN01230 >= 1 && v7742 >= 1;
  }],
  onKill: function (game, p9202, p9203, p9204) {
    var v7743 = p9203.loadout.indexOf(17);
    if (v7743 > -1) {
      if (p9204 && p9204 != p9203) {
        p9203.loadoutIndex = v7743;
        game.players.dropWeapon(p9203);
      } else {
        if (p9203.lastPicked[17] == null) {
          return;
        }
        var v7744 = game.players.findEmptyPickup(p9203.lastPicked[17], true);
        if (v7744) {
          var vA383 = [v7744.orgX, v7744.orgY, v7744.orgZ];
          game.updatePickup(v7744.uid, 17, null, true, vA383);
          game.broadcast("inat", -1, null, null, v7744.uid, 17, true, null, vA383);
        }
      }
    }
  },
  waitTimers: [{
    time: 10000,
    comp: true,
    noClear: true,
    msg: "match starting in ",
    trigger: function (game) {
      for (var vLN01232 = 0; vLN01232 < game.players.list.length; ++vLN01232) {
        if (game.players.list[vLN01232].spectating) {
          game.players.list[vLN01232].lives = 0;
        } else {
          game.players.list[vLN01232].send("gmsg", game.players.list[vLN01232].team == 2 ? "DESTROY THE OBJECTIVE" : "DEFEND THE OBJECTIVE");
        }
      }
      game.unlockMove();
    }
  }]
};